export default __webpack_public_path__ + "static/media/slip_board_body.951b1e56.png";